export default "__VITE_ASSET__C6d2giG2__"